var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-service-logo"},[(_vm.serviceLogo)?_c('img',{staticClass:"c-service-logo__img",attrs:{"src":_vm.serviceLogo,"alt":_vm.serviceName}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }